/**
 * @Description 小天才的一项评分及预估销售额
 */

import React, { FC, useMemo } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import { beautifyTheLowHighObject, isNotEmpty } from '@lhb/func';
import { Col, Row } from 'antd';
import IconFont from '@/common/components/Base/IconFont';

const ScoreFourOwnScore: FC<{
  timeDimension: any; // 销售额预测时间单位类型
  salesAmountPredict: number; // 预测营业额
  showPredictIcon?: boolean; // 预测营业额前是否展示icon，横向空间充裕场景下设置为展示
  wrapperStyle?: React.CSSProperties; // 自定义组件整体style
  wrapperClassName?: string; // 自定义组件整体classname
  valWidth?: number; // 预测营业额（含单位）显示的宽度px
  salesPredict: number;
}> = ({
  timeDimension,
  salesAmountPredict,
  wrapperStyle = {},
  wrapperClassName = '',
  salesPredict,
}) => {

  const predictValue = useMemo(() => {
    const title = `预测年营业额`;
    const title2 = `预测年销量`;
    const res = {
      val: '',
      unit: '',
      title,
      title2,
      val2: '',
      unit2: '',
    };
    const hasAmountPredict = isNotEmpty(salesAmountPredict);
    if (hasAmountPredict) {
      const amountRes = beautifyTheLowHighObject(1, salesAmountPredict, 2, { low: '元', high: '万元', top: '亿元' });
      res.val = amountRes.val;
      res.unit = amountRes.unit;
    }
    const hasSalesPredict = isNotEmpty(salesPredict);
    if (hasSalesPredict) {
      const countRes = beautifyTheLowHighObject(1, salesPredict, 2, { low: '台', high: '万台', top: '亿台' });
      res.val2 = countRes.val;
      res.unit2 = countRes.unit;
    }
    return res;
  }, [timeDimension, salesAmountPredict]);

  return (
    <div className={cs(styles.scoreAndPredict, wrapperClassName)} style={wrapperStyle}>
      <div className={cs([styles.scorePredictItem])}>
        <div className={styles.predict}>
          <Row gutter={[6, 6]}>
            <Col span={13}>
              <div className={styles.predictOuter}>
                <div className={styles.predictNum}>
                  <div className={styles.num}>{predictValue.val}</div>
                  <div className={styles.unit}>{predictValue.unit}</div>
                </div>
                <div className={styles.predictDesc}>
                  {predictValue.title}
                </div>
                <IconFont iconHref={'asset-pc-mall_yingyee'} className={styles.predictIcon}/>
              </div>
            </Col>
            <Col span={11}>
              <div className={styles.predictOuter}>
                <div className={styles.predictNum}>
                  <div className={cs([styles.num, styles.num2])}>{predictValue.val2}</div>
                  <div className={styles.unit}>{predictValue.unit2}</div>
                </div>
                <div className={styles.predictDesc}>
                  {predictValue.title2}
                </div>
                <IconFont iconHref={'asset-pc-mall_yucexiaoliang'} className={styles.predictIcon}/>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default ScoreFourOwnScore;
